module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/license.65c25c44.svg";